import type { NlsStringMap } from '../../strings_nls'
import { enStringsNls } from '../en/strings_nls'

export const zhHansStringsNls = {
  ...enStringsNls,
  NLSWhatsappInviteAction: '在WhatsApp上邀请',
  NLSWhatsappInviteDialogTitle: '在WhatsApp上邀请',
  NLSWhatsappInviteDialogCopy: '复制链接',
  NLSWhatsappInviteDialogShare: '分享',
  NLSWhatsappSendFromMineAction: '从我的WhatsApp发送',
  NLSWhatsappSendFromMineText: '你好 {name}，我是来自 {workspace} 的 {sender}。',
  NLSWhatsappSlipQrCaption: '在WhatsApp上与我们交谈',
  NLSWhatsappChipLinked: 'WhatsApp已关联',
  NLSWhatsappChipNotYet: 'WhatsApp：尚未关联',
  NLSWhatsappChipStopped: 'WhatsApp：已停止',
  NLSEduAnnouncementSendWhatsappAction: '通过WhatsApp发送',
  NLSEduAnnouncementSendWhatsappDialogTitle: '通过WhatsApp发送',
  NLSEduAnnouncementSendWhatsappDialogConfirm: '发送',
  NLSEduAnnouncementSendWhatsappSummaryRecipients: '发送给 {n} 位监护人',
  NLSEduAnnouncementSendWhatsappSummaryCredits: '发送给 {n} 位监护人 · 约 {credits} 积分',
  NLSEduAnnouncementSendWhatsappSummaryFree: '在您的套餐限额内免费',
  NLSEduAnnouncementSendWhatsappReasonOff: '此工作区已禁用WhatsApp。',
  NLSEduAnnouncementSendWhatsappReasonNotifyOff: '设置中已关闭管理员公告发送。',
  NLSEduAnnouncementSendWhatsappReasonNoRecipients: '未找到具有已验证电话同意的监护人。',
  NLSEduAnnouncementSendWhatsappReasonPaused: '由于积分不足，WhatsApp发送已暂停。',
  NLSEduAnnouncementSentWhatsappCount: '已通过WhatsApp发送给 {count} 人',
  NLSCommonRailPageShellSidecarSheet: "详细信息面板",
  NLSCommonActionBackToWorkspace: '返回工作区',
  NLSCommonActionBack: '返回',
  NLSCommonActionCancel: '取消',
  NLSCommonActionContinue: '继续',
  NLSCommonActionSignOut: '退出',
  NLSCommonActionRetryLoadingWorkspaces: '重试加载工作区',
  NLSCommonActionRetrying: '正在重试...',
  NLSCommonActionDownload: '下载',
  NLSCommonActionOpen: '打开',
  NLSCommonActionReloadThisTab: '重载此标签',
  NLSCommonActionMarkUpInDesign: '在设计中标注',
  NLSCommonAriaAccessDenied: '拒绝访问',
  NLSCommonAriaClosePreview: '关闭预览',
  NLSCommonAriaConnectionStatus: '连接状态',
  NLSCommonAriaPreviewAttachment: '预览 {label}',
  NLSCommonEmptyNoActions: '无操作',
  NLSCommonEmptyNoOptions: '无选项',
  NLSCommonErrorGeneric: '出现错误。',
  NLSCommonInputSearchPlaceholder: '搜索',
  NLSCommonInputSearchEllipsisPlaceholder: '搜索…',
  NLSCommonInputSearchOptionsPlaceholder: '搜索选项',
  NLSCommonInputSelectPlaceholder: '选择',
  NLSCommonInputSelectEllipsisPlaceholder: '选择…',
  NLSCommonStatusApi: 'API',
  NLSCommonStatusLoading: '加载中',
  NLSCommonLanguageAriaLabel: '应用语言',
  NLSCommonLanguageLabel: '语言',
  NLSCommonAccessDeniedDefaultMessage: '你的账号角色无法访问此区域。',
  NLSCommonAccessDeniedTitle: '拒绝访问',
  NLSCommonConnectivityDescription: '上次请求失败，因为此设备似乎已离线。请重新连接，然后重试刚才的操作。当前工作区仍在下方保持打开。',
  NLSCommonConnectivityEyebrow: '连接中断',
  NLSCommonConnectivityRequestPaused: '请求已暂停',
  NLSCommonConnectivityTitle: 'Timelining 无法连接网络。',
  NLSCommonPreviewAttachmentUnavailable: '附件不可用。',
  NLSCommonPreviewFormatUnavailable: '此格式无法在这里预览。你仍可打开或下载原始文件。',
  NLSCommonPreviewKindAsset: '素材',
  NLSCommonPreviewKindAudio: '音频',
  NLSCommonPreviewKindDocument: '文档',
  NLSCommonPreviewKindFile: '文件',
  NLSCommonPreviewKindImage: '图片',
  NLSCommonPreviewKindLink: '链接',
  NLSCommonPreviewKindSpreadsheet: '表格',
  NLSCommonPreviewKindTimelineItem: '时间线项',
  NLSCommonPreviewKindVideo: '视频',
  NLSCommonPreviewPreparingText: '正在准备文本预览...',
  NLSCommonPreviewTextBlocked: '此文件的文本预览被阻止。请打开或下载原始文件。',
  NLSCommonPreviewTextTruncated: '预览已截断',
  NLSCommonTabErrorBody: '应用其他部分正常。请用底部标签切换，或尝试重载此标签。',
  NLSCommonTabErrorTitle: '此标签出错',
  NLSAuthEyebrowCloudWorkspace: '云端工作区',
  NLSAuthEyebrowHelperAccess: '助手访问',
  NLSAuthTitleCloudWorkspace: '规划你的目标，或团队目标。',
  NLSAuthTitleHelperPhone: '用手机号登录。',
  NLSAuthActionCheckSession: '检查会话',
  NLSAuthActionContinueGoogle: '用 Google 继续',
  NLSAuthActionOpeningGoogle: '正在打开 Google...',
  NLSAuthActionSendOtp: '发送 OTP',
  NLSAuthActionSendingOtp: '正在发送 OTP...',
  NLSAuthActionVerifySignIn: '验证并登录',
  NLSAuthActionVerifying: '正在验证...',
  NLSAuthActionUseDifferentNumber: '使用其他号码',
  NLSAuthFieldPhoneNumber: '手机号',
  NLSAuthFieldVerificationCode: '验证码',
  NLSOnboardingEyebrowNewSpace: '新空间已准备好',
  NLSOnboardingTitleBegin: '你想从哪里开始？',
  NLSOnboardingPersonalTitle: '个人空间',
  NLSOnboardingActionLaunchPersonal: '启动个人空间',
  NLSOnboardingTeamTitleCreate: '团队工作区',
  NLSOnboardingActionExploreTeam: '探索团队选项',
  NLSOnboardingTabInvites: '邀请',
  NLSOnboardingTabDiscover: '发现',
  NLSOnboardingTabCreateNew: '新建',
  NLSShellRailSectionBoard: '看板',
  NLSShellRailSectionControls: '控制',
  NLSShellRailDays: '天',
  NLSShellRailPersonalWallet: '个人钱包',
  NLSShellRailTileDashboard: '仪表盘',
  NLSShellRailTileCalendar: '日历',
  NLSShellRailTileMembers: '成员',
  NLSShellRailTileSettings: '设置',
  NLSShellRailTileNotifications: '通知',
  NLSShellRailTileLogOut: '退出',
  NLSOpsRequestKindReliefNeeded: '需要替班',
  NLSOpsRequestKindIncident: '事件',
  NLSOpsRequestKindClientComplaint: '客户投诉',
  NLSOpsRequestKindSupplyRequest: '物资申请',
  NLSOpsRequestKindPm: '预防性维护',
  NLSOpsRequestKindCalibration: '校准',
  NLSOpsReliefNeededTitle: '需要替班：{placeName} 的 {roleLabel}（{dayKey}）',
  NLSOpsSitesPostsSubtitle: '每个站点和班次的执勤岗位 · 缺勤将发起替班请求',
  NLSOpsSitesSelectSite: '选择站点',
  NLSOpsSitesDay: '日期',
  NLSOpsSitesSelectShift: '选择班次',
  NLSOpsSitesPostsBoardTitle: '岗位与替班',
  NLSOpsSitesColPost: '岗位',
  NLSOpsSitesColNeeds: '需求',
  NLSOpsSitesColOnDuty: '在岗',
  NLSOpsSitesColState: '状态',
  NLSOpsSitesStateCovered: '已排满',
  NLSOpsSitesStateShort: '人手不足',
  NLSOpsSitesStateReliefNeeded: '需要替班',
  NLSOpsSitesStateReliefAssigned: '已安排替班',
  NLSOpsSitesNeedsFormat: '{count} {role}',
  NLSOpsSitesAbsentTag: '缺勤',
  NLSOpsSitesReliefInbox: '替班收件箱',
  NLSOpsSitesReliefFootnote: '点名册中的缺勤将自动触发 RELIEF_NEEDED 并发出岗位覆盖警告 (A6)。',
  NLSOpsSitesFreeCandidates: '空闲候选人：',
  NLSOpsSitesOffToday: '今日休假',
  NLSOpsSitesAssignBtn: '分配',
  NLSOpsSitesAssignCandidateBtn: '分配给 {name}',
  NLSOpsSitesAssignDialogTitle: '分配替班人员',
  NLSOpsSitesPrintPostSheet: '打印岗位表',
  NLSOpsSitesNoPosts: '未为此站点配置执勤岗位。',
  NLSOpsSitesNoReliefNeeded: '无需替班。',
  NLSOpsSitesNoSites: '未找到客户站点。',
  NLSOpsSitesNoShifts: '无可用班次。',
  NLSOpsSitesPostSheetTitle: '岗位表 · {siteName}',
  NLSOpsSitesPostSheetSubtitle: '{dayKey} · {shiftName}',
  NLSOpsSitesErrorStaleRequest: '无法分配替班：请求已关闭。',
  NLSOpsSitesErrorOnLeave: '无法分配替班：该人员处于已批准的请假中。',
  NLSOpsSitesErrorDoubleBooked: '无法分配替班：该人员已分配至此班次。',
  NLSOpsSitesErrorRoleCeiling: '无法分配替班：成员角色权限上限禁止此项分配。',
  NLSOpsSitesErrorGeneric: '分配替班失败。',
  NLSOpsSitesErrorNotFound: '未找到记录或请求。',
  NLSOpsSitesErrorMissingAttributes: '请求缺少必需的替班属性。',
  NLSOpsSitesErrorInactivePerson: '无法分配替班：该人员在工作区中处于未激活状态。',
  NLSOpsRequestsUnassigned: '未分配',
  NLSOpsRequestsDetailUnassigned: '未分配',
  NLSOpsSitesIncidentsSubtitle: '事件 (受限) · 客户投诉 · 物资申领 · 主管现场审核',
  NLSOpsSitesIncidentsTitle: '事件',
  NLSOpsSitesRestrictedTag: '受限',
  NLSOpsSitesAuditScoresTitle: '现场审核评分',
  NLSOpsSitesSupervisorRegisterTag: '主管登记表',
  NLSOpsSitesColSite: '站点',
  NLSOpsSitesColLastAudit: '最近审核',
  NLSOpsSitesColScore: '得分',
  NLSOpsSitesRecordAuditBtn: '记录审核',
  NLSOpsSitesComplaintsSupplyTitle: '投诉与物资申领',
  NLSOpsSitesNoIncidents: '暂无事件记录。',
  NLSOpsSitesNoComplaintsSupply: '暂无投诉或物资申领。',
  NLSOpsSitesNoAudits: '暂无现场审核记录。',
  NLSOpsSitesNoAuditTemplate: '未配置主管现场审核模板。',
  NLSOpsSitesOpenTemplatesBtn: '打开模板',
} satisfies NlsStringMap

export default zhHansStringsNls
